import { render, staticRenderFns } from "./NewsBioPanel.vue?vue&type=template&id=4b840193&"
import script from "./NewsBioPanel.vue?vue&type=script&lang=js&"
export * from "./NewsBioPanel.vue?vue&type=script&lang=js&"
import style0 from "./NewsBioPanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports